import { useFormContext } from 'framework/form';
import { Button } from 'framework/ui/mui-builder';

const BUTTON_SX = {
  width: '100%',
  mt: 3,
} as const;

type InterruptionDrawerSubmitButtonProps = {
  label?: string;
};

const InterruptionDrawerSubmitButton = ({ label = 'Submit' }: InterruptionDrawerSubmitButtonProps) => {
  const { isLoadingArtifact, isSubmitEnabled, submitForm } = useFormContext();

  return (
    <Button
      color="primary"
      variant="contained"
      sx={BUTTON_SX}
      disabled={!isSubmitEnabled || isLoadingArtifact}
      onClick={() => submitForm?.()}
    >
      {label}
    </Button>
  );
};

export default InterruptionDrawerSubmitButton;
